export enum RerouteReason {
  NotRerouted = 0,
  Weather = 1,
  Accident = 2,
  Traffic = 3,
  Other = 4,
  Construction = 5,
  Breakdown = 6,
  BringDriverHome = 7,
  MileageCorrection = 8
}

export const RerouteReasonMapping: Record<RerouteReason, string> = {
  [RerouteReason.NotRerouted]: 'Not Rerouted',
  [RerouteReason.Weather]: 'Weather',
  [RerouteReason.Accident]: 'Accident',
  [RerouteReason.Traffic]: 'Traffic',
  [RerouteReason.Other]: 'Other',
  [RerouteReason.Construction]: 'Construction',
  [RerouteReason.Breakdown]: 'Breakdown',
  [RerouteReason.BringDriverHome]: 'Bring Driver Home',
  [RerouteReason.MileageCorrection]: 'Mileage Correction'
};

export const RerouteReasonRequiringComment: RerouteReason[] = [
  RerouteReason.Weather,
  RerouteReason.Other,
  RerouteReason.Construction,
  RerouteReason.Traffic
];
